export enum PhotoMode {
  Cake = "cake",
  Landscape = "landscape",
}
